import * as React from 'react';
import DeleteConfirmationModalComponent from './DeleteConfirmationModalComponent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';
import { faMinus } from '@fortawesome/free-solid-svg-icons/faMinus';
import { CPVariable } from '../models/CPVariable';
import { useState } from 'react';
const cloneDeep = require('lodash.clonedeep')

export interface RangeComponentProps {
    variables: Array<CPVariable>
    setVariables: Function,
    previousValue: string | undefined,
    setPreviousValue: Function,
    selectedVariableId: number | undefined,
    userIsOwner: boolean,
    limitedEditing: boolean,
}

const RangeComponent = (props: RangeComponentProps) => {

    const [selectedRangeId, setSelectedRangeId] = useState<number | undefined>()

    const changeRangeVariable = range => {
        var updatedVariables = cloneDeep(props.variables)
        var previousVariableIndex = range.dataset.previousvariableindex
        var newVariableIndex = range.dataset.newvariableindex
        var rangeIndex = range.dataset.rangeindex
        var newRange = cloneDeep(updatedVariables[previousVariableIndex].rs[rangeIndex])
        updatedVariables[previousVariableIndex].rs.splice(rangeIndex, 1)
        updatedVariables[newVariableIndex].rs.push(newRange)
        props.setVariables(updatedVariables)
    }

    const changeRangeMin = range => {
        var updatedVariables = cloneDeep(props.variables)
        var variableIndex = range.dataset.variableindex
        var rangeIndex = range.dataset.rangeindex
        updatedVariables[variableIndex].rs[rangeIndex].min = range.value
        updatedVariables[variableIndex].rs[rangeIndex].minStr = range.value
        props.setVariables(updatedVariables)
    }

    const rangeMinFocus = input => {
        props.setPreviousValue(input.value)
    }

    const rangeMinBlur = input => {
        var range = cloneDeep(props.variables[input.dataset.variableindex].rs[input.dataset.rangeindex])
        range = validateMin(range)
        if (!range) {
            input.value = props.previousValue
            changeRangeMin(input)
        }
        else {
            var updatedVariables = cloneDeep(props.variables)
            updatedVariables[input.dataset.variableindex].rs[input.dataset.rangeindex] = range
            props.setVariables(updatedVariables)
        }
    }

    const changeRangeMax = range => {
        var updatedVariables = cloneDeep(props.variables)
        var variableIndex = range.dataset.variableindex
        var rangeIndex = range.dataset.rangeindex
        updatedVariables[variableIndex].rs[rangeIndex].max = range.value
        updatedVariables[variableIndex].rs[rangeIndex].maxStr = range.value
        props.setVariables(updatedVariables)
    }

    const rangeMaxFocus = input => {
        props.setPreviousValue(input.value)
    }

    const rangeMaxBlur = input => {
        var range = cloneDeep(props.variables[input.dataset.variableindex].rs[input.dataset.rangeindex])
        range = validateMax(range)
        if (!range) {
            input.value = props.previousValue
            changeRangeMax(input)
        }
        else {
            var updatedVariables = cloneDeep(props.variables)
            updatedVariables[input.dataset.variableindex].rs[input.dataset.rangeindex] = range
            props.setVariables(updatedVariables)
        }
    }

    const changeRangeIncrement = range => {
        var updatedVariables = cloneDeep(props.variables)
        var variableIndex = range.dataset.variableindex
        var rangeIndex = range.dataset.rangeindex
        updatedVariables[variableIndex].rs[rangeIndex].inc = range.value
        updatedVariables[variableIndex].rs[rangeIndex].incStr = range.value
        props.setVariables(updatedVariables)
    }

    const rangeIncrementFocus = input => {
        props.setPreviousValue(input.value)
    }

    const rangeIncrementBlur = input => {
        var range = cloneDeep(props.variables[input.dataset.variableindex].rs[input.dataset.rangeindex])
        range = validateInc(range)
        if (!range) {
            input.value = props.previousValue
            changeRangeIncrement(input)
        }
    }

    const validateMin = range => {
        var value = range.min
        var isNegativeAnswer = value[0] == "-"
        if (isNegativeAnswer) {
            value = value.substring(1)
        }
        if (value.match(/[^.\d]/)) {
            return false
        }
        if (isNaN(range.min) || range.min === "") {
            return false
        }
        if (parseFloat(range.min) > parseFloat(range.max)) {
            var newMax = range.min
            range.max = newMax
        }
        return range
    }

    const validateMax = range => {
        var value = range.max
        var isNegativeAnswer = value[0] == "-"
        if (isNegativeAnswer) {
            value = value.substring(1)
        }
        if (value.match(/[^.\d]/)) {
            return false
        }
        if (isNaN(range.max)) {
            return false
        }
        if (range.max === "") {
            range.max = range.min
        }
        if (parseFloat(range.min) > parseFloat(range.max)) {
            var newMin = range.max
            range.min = newMin
        }
        return range
    }

    const validateInc = range => {
        if (range.inc.toString().match(/[^.\d]/)) {
            return false
        }
        if (isNaN(range.inc) || range.inc === "" || range.inc <= 0) {
            return false
        }
        return range
    }

    const selectRangeRow = row => {
        setSelectedRangeId(parseInt(row.dataset.id))
    }

    const addRange = () => {
        var newId = 0
        props.variables.forEach(variable => {
            variable.rs.forEach(range => {
                var id = range.id
                if (id >= newId) {
                    newId = id + 1
                }
            })
        })
        var updatedVariables = cloneDeep(props.variables)
        if (updatedVariables.length > 0) {
            if (props.selectedVariableId != undefined) {
                var variableIndex = updatedVariables.findIndex(v => v.id == props.selectedVariableId)
                updatedVariables[variableIndex].rs.push({ "id": newId, min: 1, minStr: "1", max: 1, maxStr: "1", inc: 1, incStr: "1" })
                props.setVariables(updatedVariables)
                setSelectedRangeId(newId)
            }
            else {
                updatedVariables[0].rs.push({ "id": newId, min: 1, max: 1, inc: 1 })
                props.setVariables(updatedVariables)
                setSelectedRangeId(newId)
            }

        }
    }

    const deleteRange = () => {
        var variableIndex = getVariableIndexByRangeId(selectedRangeId)
        if (variableIndex != undefined) {
            var deleteIndex = props.variables[variableIndex].rs.findIndex(r => r.id == selectedRangeId)
            var updatedVariables = cloneDeep(props.variables)
            updatedVariables[variableIndex].rs.splice(deleteIndex, 1)
            props.setVariables(updatedVariables)
            setSelectedRangeId(undefined)
        }
    }

    const getVariableIndexByRangeId = rangeId => {
        if (rangeId != undefined) {
            for (let variableIndex = 0; variableIndex < props.variables.length; variableIndex++) {
                for (let rangeIndex = 0; rangeIndex < props.variables[variableIndex].rs.length; rangeIndex++) {
                    if (props.variables[variableIndex].rs[rangeIndex].id == rangeId) {
                        return variableIndex
                    }
                }
            }
        }
        return 0
    }

    return (
        <div className="row">
            <b><label >Ranges&emsp;
                {!props.userIsOwner || props.limitedEditing ? "" :
                    <>
                        <a role="button" onClick={addRange}><FontAwesomeIcon icon={faPlus} /> Add</a> &emsp;{selectedRangeId == undefined || <a role="button" data-bs-toggle="modal" data-bs-target="#deleteRangeModal"><FontAwesomeIcon icon={faMinus} /> Remove</a>}
                    </>}
            </label></b>
            <table className="table table-hover table-bordered table-light">
                <thead>
                    <tr>
                        <th scope="col">Variable</th>
                        <th scope="col">Range Min</th>
                        <th scope="col">Range Max</th>
                        <th scope="col">Increment</th>
                    </tr>
                </thead>
                <tbody>
                    {props.variables.map((variable, variableIndex) => (
                        variable.rs.map((range, rangeIndex) => (
                            <tr onClick={e => selectRangeRow(e.currentTarget)} data-id={range.id} key={range.id} className={selectedRangeId == range.id ? "table-active" : ""}>
                                <th scope="row">
                                    <button disabled={!props.userIsOwner || props.limitedEditing} className="btn btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {variable.name}
                                    </button>
                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        {props.variables.map((variableSelect, variableSelectIndex) => {
                                            if (!variableSelect.isDependent) {
                                                return (
                                                    <li key={variableSelect.id}><a className="dropdown-item" data-previousvariableindex={variableIndex} data-newvariableindex={variableSelectIndex} data-rangeindex={rangeIndex} onClick={e => changeRangeVariable(e.currentTarget)} >{variableSelect.name}</a></li>
                                                )
                                            }
                                        })}
                                    </ul>
                                </th>
                                <td><input disabled={!props.userIsOwner || props.limitedEditing} className="form-control" data-variableindex={variableIndex} data-rangeindex={rangeIndex} type="text" onChange={e => changeRangeMin(e.currentTarget)} onFocus={e => rangeMinFocus(e.currentTarget)} onBlur={e => rangeMinBlur(e.currentTarget)} value={props.variables[variableIndex].rs[rangeIndex].min}></input></td>
                                <td><input disabled={!props.userIsOwner || props.limitedEditing} className="form-control" data-variableindex={variableIndex} data-rangeindex={rangeIndex} type="text" onChange={e => changeRangeMax(e.currentTarget)} onFocus={e => rangeMaxFocus(e.currentTarget)} onBlur={e => rangeMaxBlur(e.currentTarget)} value={props.variables[variableIndex].rs[rangeIndex].max}></input></td>
                                <td><input disabled={!props.userIsOwner || props.limitedEditing} className="form-control" data-variableindex={variableIndex} data-rangeindex={rangeIndex} type="text" onChange={e => changeRangeIncrement(e.currentTarget)} onFocus={e => rangeIncrementFocus(e.currentTarget)} onBlur={e => rangeIncrementBlur(e.currentTarget)} value={props.variables[variableIndex].rs[rangeIndex].inc}></input></td>
                            </tr>
                        ))
                    ))}
                </tbody>
            </table>
            <DeleteConfirmationModalComponent
                itemId="deleteRangeModal"
                itemContent={"Do you want to delete this range from variable " + (selectedRangeId == undefined || props.variables[getVariableIndexByRangeId(selectedRangeId)].name) + "?"}
                deleteFunction={deleteRange}
            />
        </div>

    )
}



export default RangeComponent;